import React from "react";

export type GoogleIconProps = {
  cx?: string;
};

export const GoogleIcon: React.FC<GoogleIconProps> = ({ cx = "" }) => {
  return (
    <svg
      width="26"
      height="26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cx}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M25.48 13.295c0-.922-.083-1.808-.236-2.66H13v5.03h6.996a5.98 5.98 0 0 1-2.594 3.923v3.262h4.202c2.458-2.263 3.876-5.596 3.876-9.555z"
        fill="#4285F4"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13 26c3.51 0 6.453-1.164 8.604-3.15l-4.202-3.262c-1.164.78-2.653 1.241-4.402 1.241-3.386 0-6.252-2.287-7.274-5.36H1.383v3.369A12.995 12.995 0 0 0 13 26z"
        fill="#34A853"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.726 15.47A7.815 7.815 0 0 1 5.318 13c0-.857.148-1.69.408-2.47V7.16H1.383A12.995 12.995 0 0 0 0 13c0 2.098.502 4.083 1.383 5.838l4.343-3.368z"
        fill="#FBBC05"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13 5.17c1.909 0 3.622.656 4.97 1.945l3.728-3.73C19.447 1.289 16.504 0 13 0A12.995 12.995 0 0 0 1.383 7.162l4.343 3.368C6.748 7.457 9.614 5.17 13 5.17z"
        fill="#EA4335"
      />
    </svg>
  );
};
